// Staff header name: first name, last name, then the maiden name ("NOM de jeune fille") only when it
// differs from the last name, so a maiden name filled with the same value is not shown twice
export const getStaffDisplayName = (
  firstName?: string | null,
  lastName?: string | null,
  maidenName?: string | null
) => {
  const isSameAsLastName =
    !!maidenName && maidenName.trim().toLowerCase() === lastName?.trim().toLowerCase()

  return [firstName, lastName, isSameAsLastName ? undefined : maidenName].filter(Boolean).join(' ')
}
